module.exports = __webpack_public_path__ + "img/menu7.abf8cc7f.png";